(function (global) {
  'use strict';

  const VARIANTS = Object.freeze({
  "130:H1:50": {
    "variantId": "62048609763596",
    "priceCents": 89090,
    "sku": "DWECO-KIT-130-H1-050"
  },
  "130:H1:100": {
    "variantId": "62048609796364",
    "priceCents": 90990,
    "sku": "DWECO-KIT-130-H1-100"
  },
  "130:H1:150": {
    "variantId": "62048609829132",
    "priceCents": 90990,
    "sku": "DWECO-KIT-130-H1-150"
  },
  "130:H1:200": {
    "variantId": "62048609861900",
    "priceCents": 93090,
    "sku": "DWECO-KIT-130-H1-200"
  },
  "130:H1:250": {
    "variantId": "62048609894668",
    "priceCents": 93090,
    "sku": "DWECO-KIT-130-H1-250"
  },
  "130:H1:300": {
    "variantId": "62048609927436",
    "priceCents": 95390,
    "sku": "DWECO-KIT-130-H1-300"
  },
  "130:H1:360": {
    "variantId": "62048609960204",
    "priceCents": 97590,
    "sku": "DWECO-KIT-130-H1-360"
  },
  "130:H2:50": {
    "variantId": "62048609992972",
    "priceCents": 93090,
    "sku": "DWECO-KIT-130-H2-050"
  },
  "130:H2:100": {
    "variantId": "62048610025740",
    "priceCents": 94990,
    "sku": "DWECO-KIT-130-H2-100"
  },
  "130:H2:150": {
    "variantId": "62048610058508",
    "priceCents": 94990,
    "sku": "DWECO-KIT-130-H2-150"
  },
  "130:H2:200": {
    "variantId": "62048610091276",
    "priceCents": 97090,
    "sku": "DWECO-KIT-130-H2-200"
  },
  "130:H2:250": {
    "variantId": "62048610124044",
    "priceCents": 97090,
    "sku": "DWECO-KIT-130-H2-250"
  },
  "130:H2:300": {
    "variantId": "62048610156812",
    "priceCents": 99390,
    "sku": "DWECO-KIT-130-H2-300"
  },
  "130:H2:360": {
    "variantId": "62048610189580",
    "priceCents": 101590,
    "sku": "DWECO-KIT-130-H2-360"
  },
  "130:H3:50": {
    "variantId": "62048610222348",
    "priceCents": 96090,
    "sku": "DWECO-KIT-130-H3-050"
  },
  "130:H3:100": {
    "variantId": "62048610255116",
    "priceCents": 97990,
    "sku": "DWECO-KIT-130-H3-100"
  },
  "130:H3:150": {
    "variantId": "62048610287884",
    "priceCents": 97990,
    "sku": "DWECO-KIT-130-H3-150"
  },
  "130:H3:200": {
    "variantId": "62048610320652",
    "priceCents": 100090,
    "sku": "DWECO-KIT-130-H3-200"
  },
  "130:H3:250": {
    "variantId": "62048610353420",
    "priceCents": 100090,
    "sku": "DWECO-KIT-130-H3-250"
  },
  "130:H3:300": {
    "variantId": "62048610386188",
    "priceCents": 102390,
    "sku": "DWECO-KIT-130-H3-300"
  },
  "130:H3:360": {
    "variantId": "62048610418956",
    "priceCents": 104590,
    "sku": "DWECO-KIT-130-H3-360"
  },
  "130:H4:50": {
    "variantId": "62048610451724",
    "priceCents": 103090,
    "sku": "DWECO-KIT-130-H4-050"
  },
  "130:H4:100": {
    "variantId": "62048610484492",
    "priceCents": 104990,
    "sku": "DWECO-KIT-130-H4-100"
  },
  "130:H4:150": {
    "variantId": "62048610517260",
    "priceCents": 104990,
    "sku": "DWECO-KIT-130-H4-150"
  },
  "130:H4:200": {
    "variantId": "62048610550028",
    "priceCents": 107090,
    "sku": "DWECO-KIT-130-H4-200"
  },
  "130:H4:250": {
    "variantId": "62048610582796",
    "priceCents": 107090,
    "sku": "DWECO-KIT-130-H4-250"
  },
  "130:H4:300": {
    "variantId": "62048610615564",
    "priceCents": 109390,
    "sku": "DWECO-KIT-130-H4-300"
  },
  "130:H4:360": {
    "variantId": "62048610648332",
    "priceCents": 111590,
    "sku": "DWECO-KIT-130-H4-360"
  },
  "130:H5:50": {
    "variantId": "62048610681100",
    "priceCents": 100090,
    "sku": "DWECO-KIT-130-H5-050"
  },
  "130:H5:100": {
    "variantId": "62048610713868",
    "priceCents": 101990,
    "sku": "DWECO-KIT-130-H5-100"
  },
  "130:H5:150": {
    "variantId": "62048610746636",
    "priceCents": 101990,
    "sku": "DWECO-KIT-130-H5-150"
  },
  "130:H5:200": {
    "variantId": "62048610779404",
    "priceCents": 104090,
    "sku": "DWECO-KIT-130-H5-200"
  },
  "130:H5:250": {
    "variantId": "62048610812172",
    "priceCents": 104090,
    "sku": "DWECO-KIT-130-H5-250"
  },
  "130:H5:300": {
    "variantId": "62048610844940",
    "priceCents": 106390,
    "sku": "DWECO-KIT-130-H5-300"
  },
  "130:H5:360": {
    "variantId": "62048610877708",
    "priceCents": 108590,
    "sku": "DWECO-KIT-130-H5-360"
  },
  "130:H6:50": {
    "variantId": "62048610910476",
    "priceCents": 109090,
    "sku": "DWECO-KIT-130-H6-050"
  },
  "130:H6:100": {
    "variantId": "62048610943244",
    "priceCents": 110990,
    "sku": "DWECO-KIT-130-H6-100"
  },
  "130:H6:150": {
    "variantId": "62048610976012",
    "priceCents": 110990,
    "sku": "DWECO-KIT-130-H6-150"
  },
  "130:H6:200": {
    "variantId": "62048611008780",
    "priceCents": 113090,
    "sku": "DWECO-KIT-130-H6-200"
  },
  "130:H6:250": {
    "variantId": "62048611041548",
    "priceCents": 113090,
    "sku": "DWECO-KIT-130-H6-250"
  },
  "130:H6:300": {
    "variantId": "62048611074316",
    "priceCents": 115390,
    "sku": "DWECO-KIT-130-H6-300"
  },
  "130:H6:360": {
    "variantId": "62048611107084",
    "priceCents": 117590,
    "sku": "DWECO-KIT-130-H6-360"
  },
  "130:H7:50": {
    "variantId": "62048611139852",
    "priceCents": 122190,
    "sku": "DWECO-KIT-130-H7-050"
  },
  "130:H7:100": {
    "variantId": "62048611172620",
    "priceCents": 125990,
    "sku": "DWECO-KIT-130-H7-100"
  },
  "130:H7:150": {
    "variantId": "62048611205388",
    "priceCents": 125990,
    "sku": "DWECO-KIT-130-H7-150"
  },
  "130:H7:200": {
    "variantId": "62048611238156",
    "priceCents": 129190,
    "sku": "DWECO-KIT-130-H7-200"
  },
  "130:H7:250": {
    "variantId": "62048611270924",
    "priceCents": 129190,
    "sku": "DWECO-KIT-130-H7-250"
  },
  "130:H7:300": {
    "variantId": "62048611303692",
    "priceCents": 133790,
    "sku": "DWECO-KIT-130-H7-300"
  },
  "130:H7:360": {
    "variantId": "62048611336460",
    "priceCents": 135990,
    "sku": "DWECO-KIT-130-H7-360"
  },
  "130:H8:50": {
    "variantId": "62048611369228",
    "priceCents": 130190,
    "sku": "DWECO-KIT-130-H8-050"
  },
  "130:H8:100": {
    "variantId": "62048611401996",
    "priceCents": 133990,
    "sku": "DWECO-KIT-130-H8-100"
  },
  "130:H8:150": {
    "variantId": "62048611434764",
    "priceCents": 133990,
    "sku": "DWECO-KIT-130-H8-150"
  },
  "130:H8:200": {
    "variantId": "62048611467532",
    "priceCents": 137190,
    "sku": "DWECO-KIT-130-H8-200"
  },
  "130:H8:250": {
    "variantId": "62048611500300",
    "priceCents": 137190,
    "sku": "DWECO-KIT-130-H8-250"
  },
  "130:H8:300": {
    "variantId": "62048611533068",
    "priceCents": 141790,
    "sku": "DWECO-KIT-130-H8-300"
  },
  "130:H8:360": {
    "variantId": "62048611565836",
    "priceCents": 143990,
    "sku": "DWECO-KIT-130-H8-360"
  },
  "130:H9:50": {
    "variantId": "62048611598604",
    "priceCents": 141190,
    "sku": "DWECO-KIT-130-H9-050"
  },
  "130:H9:100": {
    "variantId": "62048611631372",
    "priceCents": 144990,
    "sku": "DWECO-KIT-130-H9-100"
  },
  "130:H9:150": {
    "variantId": "62048611664140",
    "priceCents": 144990,
    "sku": "DWECO-KIT-130-H9-150"
  },
  "130:H9:200": {
    "variantId": "62048611696908",
    "priceCents": 148190,
    "sku": "DWECO-KIT-130-H9-200"
  },
  "130:H9:250": {
    "variantId": "62048611729676",
    "priceCents": 148190,
    "sku": "DWECO-KIT-130-H9-250"
  },
  "130:H9:300": {
    "variantId": "62048611762444",
    "priceCents": 152790,
    "sku": "DWECO-KIT-130-H9-300"
  },
  "130:H9:360": {
    "variantId": "62048611795212",
    "priceCents": 154990,
    "sku": "DWECO-KIT-130-H9-360"
  },
  "130:H10:50": {
    "variantId": "62048611827980",
    "priceCents": 151190,
    "sku": "DWECO-KIT-130-H10-050"
  },
  "130:H10:100": {
    "variantId": "62048611860748",
    "priceCents": 154990,
    "sku": "DWECO-KIT-130-H10-100"
  },
  "130:H10:150": {
    "variantId": "62048611893516",
    "priceCents": 154990,
    "sku": "DWECO-KIT-130-H10-150"
  },
  "130:H10:200": {
    "variantId": "62048611926284",
    "priceCents": 158190,
    "sku": "DWECO-KIT-130-H10-200"
  },
  "130:H10:250": {
    "variantId": "62048611959052",
    "priceCents": 158190,
    "sku": "DWECO-KIT-130-H10-250"
  },
  "130:H10:300": {
    "variantId": "62048611991820",
    "priceCents": 162790,
    "sku": "DWECO-KIT-130-H10-300"
  },
  "130:H10:360": {
    "variantId": "62048612024588",
    "priceCents": 164990,
    "sku": "DWECO-KIT-130-H10-360"
  },
  "130:H11:50": {
    "variantId": "62048612057356",
    "priceCents": 165290,
    "sku": "DWECO-KIT-130-H11-050"
  },
  "130:H11:100": {
    "variantId": "62048612090124",
    "priceCents": 170990,
    "sku": "DWECO-KIT-130-H11-100"
  },
  "130:H11:150": {
    "variantId": "62048612122892",
    "priceCents": 170990,
    "sku": "DWECO-KIT-130-H11-150"
  },
  "130:H11:200": {
    "variantId": "62048612155660",
    "priceCents": 175290,
    "sku": "DWECO-KIT-130-H11-200"
  },
  "130:H11:250": {
    "variantId": "62048612188428",
    "priceCents": 175290,
    "sku": "DWECO-KIT-130-H11-250"
  },
  "130:H11:300": {
    "variantId": "62048612221196",
    "priceCents": 182190,
    "sku": "DWECO-KIT-130-H11-300"
  },
  "130:H11:360": {
    "variantId": "62048612253964",
    "priceCents": 184390,
    "sku": "DWECO-KIT-130-H11-360"
  },
  "150:H1:50": {
    "variantId": "62048612286732",
    "priceCents": 93390,
    "sku": "DWECO-KIT-150-H1-050"
  },
  "150:H1:100": {
    "variantId": "62048612319500",
    "priceCents": 94990,
    "sku": "DWECO-KIT-150-H1-100"
  },
  "150:H1:150": {
    "variantId": "62048612352268",
    "priceCents": 95990,
    "sku": "DWECO-KIT-150-H1-150"
  },
  "150:H1:200": {
    "variantId": "62048612385036",
    "priceCents": 97390,
    "sku": "DWECO-KIT-150-H1-200"
  },
  "150:H1:250": {
    "variantId": "62048612417804",
    "priceCents": 97390,
    "sku": "DWECO-KIT-150-H1-250"
  },
  "150:H1:300": {
    "variantId": "62048612450572",
    "priceCents": 101690,
    "sku": "DWECO-KIT-150-H1-300"
  },
  "150:H1:360": {
    "variantId": "62048612483340",
    "priceCents": 101690,
    "sku": "DWECO-KIT-150-H1-360"
  },
  "150:H2:50": {
    "variantId": "62048612516108",
    "priceCents": 98390,
    "sku": "DWECO-KIT-150-H2-050"
  },
  "150:H2:100": {
    "variantId": "62048612548876",
    "priceCents": 99990,
    "sku": "DWECO-KIT-150-H2-100"
  },
  "150:H2:150": {
    "variantId": "62048612581644",
    "priceCents": 100990,
    "sku": "DWECO-KIT-150-H2-150"
  },
  "150:H2:200": {
    "variantId": "62048612614412",
    "priceCents": 102390,
    "sku": "DWECO-KIT-150-H2-200"
  },
  "150:H2:250": {
    "variantId": "62048612647180",
    "priceCents": 102390,
    "sku": "DWECO-KIT-150-H2-250"
  },
  "150:H2:300": {
    "variantId": "62048612679948",
    "priceCents": 106690,
    "sku": "DWECO-KIT-150-H2-300"
  },
  "150:H2:360": {
    "variantId": "62048612712716",
    "priceCents": 106690,
    "sku": "DWECO-KIT-150-H2-360"
  },
  "150:H3:50": {
    "variantId": "62048612745484",
    "priceCents": 103390,
    "sku": "DWECO-KIT-150-H3-050"
  },
  "150:H3:100": {
    "variantId": "62048612778252",
    "priceCents": 104990,
    "sku": "DWECO-KIT-150-H3-100"
  },
  "150:H3:150": {
    "variantId": "62048612811020",
    "priceCents": 105990,
    "sku": "DWECO-KIT-150-H3-150"
  },
  "150:H3:200": {
    "variantId": "62048612843788",
    "priceCents": 107390,
    "sku": "DWECO-KIT-150-H3-200"
  },
  "150:H3:250": {
    "variantId": "62048612876556",
    "priceCents": 107390,
    "sku": "DWECO-KIT-150-H3-250"
  },
  "150:H3:300": {
    "variantId": "62048612909324",
    "priceCents": 111690,
    "sku": "DWECO-KIT-150-H3-300"
  },
  "150:H3:360": {
    "variantId": "62048612942092",
    "priceCents": 111690,
    "sku": "DWECO-KIT-150-H3-360"
  },
  "150:H4:50": {
    "variantId": "62048612974860",
    "priceCents": 108390,
    "sku": "DWECO-KIT-150-H4-050"
  },
  "150:H4:100": {
    "variantId": "62048613007628",
    "priceCents": 109990,
    "sku": "DWECO-KIT-150-H4-100"
  },
  "150:H4:150": {
    "variantId": "62048613040396",
    "priceCents": 110990,
    "sku": "DWECO-KIT-150-H4-150"
  },
  "150:H4:200": {
    "variantId": "62048613073164",
    "priceCents": 112390,
    "sku": "DWECO-KIT-150-H4-200"
  },
  "150:H4:250": {
    "variantId": "62048613105932",
    "priceCents": 112390,
    "sku": "DWECO-KIT-150-H4-250"
  },
  "150:H4:300": {
    "variantId": "62048613138700",
    "priceCents": 116690,
    "sku": "DWECO-KIT-150-H4-300"
  },
  "150:H4:360": {
    "variantId": "62048613171468",
    "priceCents": 116690,
    "sku": "DWECO-KIT-150-H4-360"
  },
  "150:H5:50": {
    "variantId": "62048613204236",
    "priceCents": 105390,
    "sku": "DWECO-KIT-150-H5-050"
  },
  "150:H5:100": {
    "variantId": "62048613237004",
    "priceCents": 106990,
    "sku": "DWECO-KIT-150-H5-100"
  },
  "150:H5:150": {
    "variantId": "62048613269772",
    "priceCents": 107990,
    "sku": "DWECO-KIT-150-H5-150"
  },
  "150:H5:200": {
    "variantId": "62048613302540",
    "priceCents": 109390,
    "sku": "DWECO-KIT-150-H5-200"
  },
  "150:H5:250": {
    "variantId": "62048613335308",
    "priceCents": 109390,
    "sku": "DWECO-KIT-150-H5-250"
  },
  "150:H5:300": {
    "variantId": "62048613368076",
    "priceCents": 113690,
    "sku": "DWECO-KIT-150-H5-300"
  },
  "150:H5:360": {
    "variantId": "62048613400844",
    "priceCents": 113690,
    "sku": "DWECO-KIT-150-H5-360"
  },
  "150:H6:50": {
    "variantId": "62048613433612",
    "priceCents": 115390,
    "sku": "DWECO-KIT-150-H6-050"
  },
  "150:H6:100": {
    "variantId": "62048613466380",
    "priceCents": 116990,
    "sku": "DWECO-KIT-150-H6-100"
  },
  "150:H6:150": {
    "variantId": "62048613499148",
    "priceCents": 117990,
    "sku": "DWECO-KIT-150-H6-150"
  },
  "150:H6:200": {
    "variantId": "62048613531916",
    "priceCents": 119390,
    "sku": "DWECO-KIT-150-H6-200"
  },
  "150:H6:250": {
    "variantId": "62048613564684",
    "priceCents": 119390,
    "sku": "DWECO-KIT-150-H6-250"
  },
  "150:H6:300": {
    "variantId": "62048613597452",
    "priceCents": 123690,
    "sku": "DWECO-KIT-150-H6-300"
  },
  "150:H6:360": {
    "variantId": "62048613630220",
    "priceCents": 123690,
    "sku": "DWECO-KIT-150-H6-360"
  },
  "150:H7:50": {
    "variantId": "62048613662988",
    "priceCents": 130790,
    "sku": "DWECO-KIT-150-H7-050"
  },
  "150:H7:100": {
    "variantId": "62048613695756",
    "priceCents": 133990,
    "sku": "DWECO-KIT-150-H7-100"
  },
  "150:H7:150": {
    "variantId": "62048613728524",
    "priceCents": 134990,
    "sku": "DWECO-KIT-150-H7-150"
  },
  "150:H7:200": {
    "variantId": "62048613761292",
    "priceCents": 137790,
    "sku": "DWECO-KIT-150-H7-200"
  },
  "150:H7:250": {
    "variantId": "62048613794060",
    "priceCents": 137790,
    "sku": "DWECO-KIT-150-H7-250"
  },
  "150:H7:300": {
    "variantId": "62048613826828",
    "priceCents": 144190,
    "sku": "DWECO-KIT-150-H7-300"
  },
  "150:H7:360": {
    "variantId": "62048613859596",
    "priceCents": 144190,
    "sku": "DWECO-KIT-150-H7-360"
  },
  "150:H8:50": {
    "variantId": "62048613892364",
    "priceCents": 142790,
    "sku": "DWECO-KIT-150-H8-050"
  },
  "150:H8:100": {
    "variantId": "62048613925132",
    "priceCents": 145990,
    "sku": "DWECO-KIT-150-H8-100"
  },
  "150:H8:150": {
    "variantId": "62048613957900",
    "priceCents": 146990,
    "sku": "DWECO-KIT-150-H8-150"
  },
  "150:H8:200": {
    "variantId": "62048613990668",
    "priceCents": 149790,
    "sku": "DWECO-KIT-150-H8-200"
  },
  "150:H8:250": {
    "variantId": "62048614023436",
    "priceCents": 149790,
    "sku": "DWECO-KIT-150-H8-250"
  },
  "150:H8:300": {
    "variantId": "62048614056204",
    "priceCents": 156190,
    "sku": "DWECO-KIT-150-H8-300"
  },
  "150:H8:360": {
    "variantId": "62048614088972",
    "priceCents": 156190,
    "sku": "DWECO-KIT-150-H8-360"
  },
  "150:H9:50": {
    "variantId": "62048614121740",
    "priceCents": 153790,
    "sku": "DWECO-KIT-150-H9-050"
  },
  "150:H9:100": {
    "variantId": "62048614154508",
    "priceCents": 156990,
    "sku": "DWECO-KIT-150-H9-100"
  },
  "150:H9:150": {
    "variantId": "62048614187276",
    "priceCents": 157990,
    "sku": "DWECO-KIT-150-H9-150"
  },
  "150:H9:200": {
    "variantId": "62048614220044",
    "priceCents": 160790,
    "sku": "DWECO-KIT-150-H9-200"
  },
  "150:H9:250": {
    "variantId": "62048614252812",
    "priceCents": 160790,
    "sku": "DWECO-KIT-150-H9-250"
  },
  "150:H9:300": {
    "variantId": "62048614285580",
    "priceCents": 167190,
    "sku": "DWECO-KIT-150-H9-300"
  },
  "150:H9:360": {
    "variantId": "62048614318348",
    "priceCents": 167190,
    "sku": "DWECO-KIT-150-H9-360"
  },
  "150:H10:50": {
    "variantId": "62048614351116",
    "priceCents": 165790,
    "sku": "DWECO-KIT-150-H10-050"
  },
  "150:H10:100": {
    "variantId": "62048614383884",
    "priceCents": 168990,
    "sku": "DWECO-KIT-150-H10-100"
  },
  "150:H10:150": {
    "variantId": "62048614416652",
    "priceCents": 169990,
    "sku": "DWECO-KIT-150-H10-150"
  },
  "150:H10:200": {
    "variantId": "62048614449420",
    "priceCents": 172790,
    "sku": "DWECO-KIT-150-H10-200"
  },
  "150:H10:250": {
    "variantId": "62048614482188",
    "priceCents": 172790,
    "sku": "DWECO-KIT-150-H10-250"
  },
  "150:H10:300": {
    "variantId": "62048614514956",
    "priceCents": 179190,
    "sku": "DWECO-KIT-150-H10-300"
  },
  "150:H10:360": {
    "variantId": "62048614547724",
    "priceCents": 179190,
    "sku": "DWECO-KIT-150-H10-360"
  },
  "150:H11:50": {
    "variantId": "62048614580492",
    "priceCents": 181190,
    "sku": "DWECO-KIT-150-H11-050"
  },
  "150:H11:100": {
    "variantId": "62048614613260",
    "priceCents": 185990,
    "sku": "DWECO-KIT-150-H11-100"
  },
  "150:H11:150": {
    "variantId": "62048614646028",
    "priceCents": 186990,
    "sku": "DWECO-KIT-150-H11-150"
  },
  "150:H11:200": {
    "variantId": "62048614678796",
    "priceCents": 191190,
    "sku": "DWECO-KIT-150-H11-200"
  },
  "150:H11:250": {
    "variantId": "62048614711564",
    "priceCents": 191190,
    "sku": "DWECO-KIT-150-H11-250"
  },
  "150:H11:300": {
    "variantId": "62048614744332",
    "priceCents": 199690,
    "sku": "DWECO-KIT-150-H11-300"
  },
  "150:H11:360": {
    "variantId": "62048614777100",
    "priceCents": 199690,
    "sku": "DWECO-KIT-150-H11-360"
  },
  "160:H1:50": {
    "variantId": "62048614809868",
    "priceCents": 95190,
    "sku": "DWECO-KIT-160-H1-050"
  },
  "160:H1:100": {
    "variantId": "62048614842636",
    "priceCents": 96990,
    "sku": "DWECO-KIT-160-H1-100"
  },
  "160:H1:150": {
    "variantId": "62048614875404",
    "priceCents": 97990,
    "sku": "DWECO-KIT-160-H1-150"
  },
  "160:H1:200": {
    "variantId": "62048614908172",
    "priceCents": 99190,
    "sku": "DWECO-KIT-160-H1-200"
  },
  "160:H1:250": {
    "variantId": "62048614940940",
    "priceCents": 99190,
    "sku": "DWECO-KIT-160-H1-250"
  },
  "160:H1:300": {
    "variantId": "62048614973708",
    "priceCents": 103590,
    "sku": "DWECO-KIT-160-H1-300"
  },
  "160:H1:360": {
    "variantId": "62048615006476",
    "priceCents": 103590,
    "sku": "DWECO-KIT-160-H1-360"
  },
  "160:H2:50": {
    "variantId": "62048615039244",
    "priceCents": 101190,
    "sku": "DWECO-KIT-160-H2-050"
  },
  "160:H2:100": {
    "variantId": "62048615072012",
    "priceCents": 102990,
    "sku": "DWECO-KIT-160-H2-100"
  },
  "160:H2:150": {
    "variantId": "62048615104780",
    "priceCents": 103990,
    "sku": "DWECO-KIT-160-H2-150"
  },
  "160:H2:200": {
    "variantId": "62048615137548",
    "priceCents": 105190,
    "sku": "DWECO-KIT-160-H2-200"
  },
  "160:H2:250": {
    "variantId": "62048615170316",
    "priceCents": 105190,
    "sku": "DWECO-KIT-160-H2-250"
  },
  "160:H2:300": {
    "variantId": "62048615203084",
    "priceCents": 109590,
    "sku": "DWECO-KIT-160-H2-300"
  },
  "160:H2:360": {
    "variantId": "62048615235852",
    "priceCents": 109590,
    "sku": "DWECO-KIT-160-H2-360"
  },
  "160:H3:50": {
    "variantId": "62048615268620",
    "priceCents": 106190,
    "sku": "DWECO-KIT-160-H3-050"
  },
  "160:H3:100": {
    "variantId": "62048615301388",
    "priceCents": 107990,
    "sku": "DWECO-KIT-160-H3-100"
  },
  "160:H3:150": {
    "variantId": "62048615334156",
    "priceCents": 108990,
    "sku": "DWECO-KIT-160-H3-150"
  },
  "160:H3:200": {
    "variantId": "62048615366924",
    "priceCents": 110190,
    "sku": "DWECO-KIT-160-H3-200"
  },
  "160:H3:250": {
    "variantId": "62048615399692",
    "priceCents": 110190,
    "sku": "DWECO-KIT-160-H3-250"
  },
  "160:H3:300": {
    "variantId": "62048615432460",
    "priceCents": 114590,
    "sku": "DWECO-KIT-160-H3-300"
  },
  "160:H3:360": {
    "variantId": "62048615465228",
    "priceCents": 114590,
    "sku": "DWECO-KIT-160-H3-360"
  },
  "160:H4:50": {
    "variantId": "62048615497996",
    "priceCents": 111190,
    "sku": "DWECO-KIT-160-H4-050"
  },
  "160:H4:100": {
    "variantId": "62048615530764",
    "priceCents": 112990,
    "sku": "DWECO-KIT-160-H4-100"
  },
  "160:H4:150": {
    "variantId": "62048615563532",
    "priceCents": 113990,
    "sku": "DWECO-KIT-160-H4-150"
  },
  "160:H4:200": {
    "variantId": "62048615596300",
    "priceCents": 115190,
    "sku": "DWECO-KIT-160-H4-200"
  },
  "160:H4:250": {
    "variantId": "62048615629068",
    "priceCents": 115190,
    "sku": "DWECO-KIT-160-H4-250"
  },
  "160:H4:300": {
    "variantId": "62048615661836",
    "priceCents": 119590,
    "sku": "DWECO-KIT-160-H4-300"
  },
  "160:H4:360": {
    "variantId": "62048615694604",
    "priceCents": 119590,
    "sku": "DWECO-KIT-160-H4-360"
  },
  "160:H5:50": {
    "variantId": "62048615727372",
    "priceCents": 107190,
    "sku": "DWECO-KIT-160-H5-050"
  },
  "160:H5:100": {
    "variantId": "62048615760140",
    "priceCents": 108990,
    "sku": "DWECO-KIT-160-H5-100"
  },
  "160:H5:150": {
    "variantId": "62048615792908",
    "priceCents": 109990,
    "sku": "DWECO-KIT-160-H5-150"
  },
  "160:H5:200": {
    "variantId": "62048615825676",
    "priceCents": 111190,
    "sku": "DWECO-KIT-160-H5-200"
  },
  "160:H5:250": {
    "variantId": "62048615858444",
    "priceCents": 111190,
    "sku": "DWECO-KIT-160-H5-250"
  },
  "160:H5:300": {
    "variantId": "62048615891212",
    "priceCents": 115590,
    "sku": "DWECO-KIT-160-H5-300"
  },
  "160:H5:360": {
    "variantId": "62048615923980",
    "priceCents": 115590,
    "sku": "DWECO-KIT-160-H5-360"
  },
  "160:H6:50": {
    "variantId": "62048615956748",
    "priceCents": 119190,
    "sku": "DWECO-KIT-160-H6-050"
  },
  "160:H6:100": {
    "variantId": "62048615989516",
    "priceCents": 120990,
    "sku": "DWECO-KIT-160-H6-100"
  },
  "160:H6:150": {
    "variantId": "62048616022284",
    "priceCents": 121990,
    "sku": "DWECO-KIT-160-H6-150"
  },
  "160:H6:200": {
    "variantId": "62048616055052",
    "priceCents": 123190,
    "sku": "DWECO-KIT-160-H6-200"
  },
  "160:H6:250": {
    "variantId": "62048616087820",
    "priceCents": 123190,
    "sku": "DWECO-KIT-160-H6-250"
  },
  "160:H6:300": {
    "variantId": "62048616120588",
    "priceCents": 127590,
    "sku": "DWECO-KIT-160-H6-300"
  },
  "160:H6:360": {
    "variantId": "62048616153356",
    "priceCents": 127590,
    "sku": "DWECO-KIT-160-H6-360"
  },
  "160:H7:50": {
    "variantId": "62048616186124",
    "priceCents": 135390,
    "sku": "DWECO-KIT-160-H7-050"
  },
  "160:H7:100": {
    "variantId": "62048616218892",
    "priceCents": 138990,
    "sku": "DWECO-KIT-160-H7-100"
  },
  "160:H7:150": {
    "variantId": "62048616251660",
    "priceCents": 139990,
    "sku": "DWECO-KIT-160-H7-150"
  },
  "160:H7:200": {
    "variantId": "62048616284428",
    "priceCents": 142390,
    "sku": "DWECO-KIT-160-H7-200"
  },
  "160:H7:250": {
    "variantId": "62048616317196",
    "priceCents": 142390,
    "sku": "DWECO-KIT-160-H7-250"
  },
  "160:H7:300": {
    "variantId": "62048616349964",
    "priceCents": 148990,
    "sku": "DWECO-KIT-160-H7-300"
  },
  "160:H7:360": {
    "variantId": "62048616382732",
    "priceCents": 148990,
    "sku": "DWECO-KIT-160-H7-360"
  },
  "160:H8:50": {
    "variantId": "62048616415500",
    "priceCents": 147390,
    "sku": "DWECO-KIT-160-H8-050"
  },
  "160:H8:100": {
    "variantId": "62048616448268",
    "priceCents": 150990,
    "sku": "DWECO-KIT-160-H8-100"
  },
  "160:H8:150": {
    "variantId": "62048616481036",
    "priceCents": 151990,
    "sku": "DWECO-KIT-160-H8-150"
  },
  "160:H8:200": {
    "variantId": "62048616513804",
    "priceCents": 154390,
    "sku": "DWECO-KIT-160-H8-200"
  },
  "160:H8:250": {
    "variantId": "62048616546572",
    "priceCents": 154390,
    "sku": "DWECO-KIT-160-H8-250"
  },
  "160:H8:300": {
    "variantId": "62048616579340",
    "priceCents": 160990,
    "sku": "DWECO-KIT-160-H8-300"
  },
  "160:H8:360": {
    "variantId": "62048616612108",
    "priceCents": 160990,
    "sku": "DWECO-KIT-160-H8-360"
  },
  "160:H9:50": {
    "variantId": "62048616644876",
    "priceCents": 160390,
    "sku": "DWECO-KIT-160-H9-050"
  },
  "160:H9:100": {
    "variantId": "62048616677644",
    "priceCents": 163990,
    "sku": "DWECO-KIT-160-H9-100"
  },
  "160:H9:150": {
    "variantId": "62048616710412",
    "priceCents": 164990,
    "sku": "DWECO-KIT-160-H9-150"
  },
  "160:H9:200": {
    "variantId": "62048616743180",
    "priceCents": 167390,
    "sku": "DWECO-KIT-160-H9-200"
  },
  "160:H9:250": {
    "variantId": "62048616775948",
    "priceCents": 167390,
    "sku": "DWECO-KIT-160-H9-250"
  },
  "160:H9:300": {
    "variantId": "62048616808716",
    "priceCents": 173990,
    "sku": "DWECO-KIT-160-H9-300"
  },
  "160:H9:360": {
    "variantId": "62048616841484",
    "priceCents": 173990,
    "sku": "DWECO-KIT-160-H9-360"
  },
  "160:H10:50": {
    "variantId": "62048616874252",
    "priceCents": 172390,
    "sku": "DWECO-KIT-160-H10-050"
  },
  "160:H10:100": {
    "variantId": "62048616907020",
    "priceCents": 175990,
    "sku": "DWECO-KIT-160-H10-100"
  },
  "160:H10:150": {
    "variantId": "62048616939788",
    "priceCents": 176990,
    "sku": "DWECO-KIT-160-H10-150"
  },
  "160:H10:200": {
    "variantId": "62048616972556",
    "priceCents": 179390,
    "sku": "DWECO-KIT-160-H10-200"
  },
  "160:H10:250": {
    "variantId": "62048617005324",
    "priceCents": 179390,
    "sku": "DWECO-KIT-160-H10-250"
  },
  "160:H10:300": {
    "variantId": "62048617038092",
    "priceCents": 185990,
    "sku": "DWECO-KIT-160-H10-300"
  },
  "160:H10:360": {
    "variantId": "62048617070860",
    "priceCents": 185990,
    "sku": "DWECO-KIT-160-H10-360"
  },
  "160:H11:50": {
    "variantId": "62048617103628",
    "priceCents": 189590,
    "sku": "DWECO-KIT-160-H11-050"
  },
  "160:H11:100": {
    "variantId": "62048617136396",
    "priceCents": 194990,
    "sku": "DWECO-KIT-160-H11-100"
  },
  "160:H11:150": {
    "variantId": "62048617169164",
    "priceCents": 195990,
    "sku": "DWECO-KIT-160-H11-150"
  },
  "160:H11:200": {
    "variantId": "62048617201932",
    "priceCents": 199590,
    "sku": "DWECO-KIT-160-H11-200"
  },
  "160:H11:250": {
    "variantId": "62048617234700",
    "priceCents": 199590,
    "sku": "DWECO-KIT-160-H11-250"
  },
  "160:H11:300": {
    "variantId": "62048617267468",
    "priceCents": 208390,
    "sku": "DWECO-KIT-160-H11-300"
  },
  "160:H11:360": {
    "variantId": "62048617300236",
    "priceCents": 208390,
    "sku": "DWECO-KIT-160-H11-360"
  },
  "180:H1:50": {
    "variantId": "62048617333004",
    "priceCents": 97090,
    "sku": "DWECO-KIT-180-H1-050"
  },
  "180:H1:100": {
    "variantId": "62048617365772",
    "priceCents": 98990,
    "sku": "DWECO-KIT-180-H1-100"
  },
  "180:H1:150": {
    "variantId": "62048617398540",
    "priceCents": 99990,
    "sku": "DWECO-KIT-180-H1-150"
  },
  "180:H1:200": {
    "variantId": "62048617431308",
    "priceCents": 101190,
    "sku": "DWECO-KIT-180-H1-200"
  },
  "180:H1:250": {
    "variantId": "62048617464076",
    "priceCents": 101190,
    "sku": "DWECO-KIT-180-H1-250"
  },
  "180:H1:300": {
    "variantId": "62048617496844",
    "priceCents": 105590,
    "sku": "DWECO-KIT-180-H1-300"
  },
  "180:H1:360": {
    "variantId": "62048617529612",
    "priceCents": 105590,
    "sku": "DWECO-KIT-180-H1-360"
  },
  "180:H2:50": {
    "variantId": "62048617562380",
    "priceCents": 104090,
    "sku": "DWECO-KIT-180-H2-050"
  },
  "180:H2:100": {
    "variantId": "62048617595148",
    "priceCents": 105990,
    "sku": "DWECO-KIT-180-H2-100"
  },
  "180:H2:150": {
    "variantId": "62048617627916",
    "priceCents": 106990,
    "sku": "DWECO-KIT-180-H2-150"
  },
  "180:H2:200": {
    "variantId": "62048617660684",
    "priceCents": 108190,
    "sku": "DWECO-KIT-180-H2-200"
  },
  "180:H2:250": {
    "variantId": "62048617693452",
    "priceCents": 108190,
    "sku": "DWECO-KIT-180-H2-250"
  },
  "180:H2:300": {
    "variantId": "62048617726220",
    "priceCents": 112590,
    "sku": "DWECO-KIT-180-H2-300"
  },
  "180:H2:360": {
    "variantId": "62048617758988",
    "priceCents": 112590,
    "sku": "DWECO-KIT-180-H2-360"
  },
  "180:H3:50": {
    "variantId": "62048617791756",
    "priceCents": 110090,
    "sku": "DWECO-KIT-180-H3-050"
  },
  "180:H3:100": {
    "variantId": "62048617824524",
    "priceCents": 111990,
    "sku": "DWECO-KIT-180-H3-100"
  },
  "180:H3:150": {
    "variantId": "62048617857292",
    "priceCents": 112990,
    "sku": "DWECO-KIT-180-H3-150"
  },
  "180:H3:200": {
    "variantId": "62048617890060",
    "priceCents": 114190,
    "sku": "DWECO-KIT-180-H3-200"
  },
  "180:H3:250": {
    "variantId": "62048617922828",
    "priceCents": 114190,
    "sku": "DWECO-KIT-180-H3-250"
  },
  "180:H3:300": {
    "variantId": "62048617955596",
    "priceCents": 118590,
    "sku": "DWECO-KIT-180-H3-300"
  },
  "180:H3:360": {
    "variantId": "62048617988364",
    "priceCents": 118590,
    "sku": "DWECO-KIT-180-H3-360"
  },
  "180:H4:50": {
    "variantId": "62048618021132",
    "priceCents": 115090,
    "sku": "DWECO-KIT-180-H4-050"
  },
  "180:H4:100": {
    "variantId": "62048618053900",
    "priceCents": 116990,
    "sku": "DWECO-KIT-180-H4-100"
  },
  "180:H4:150": {
    "variantId": "62048618086668",
    "priceCents": 117990,
    "sku": "DWECO-KIT-180-H4-150"
  },
  "180:H4:200": {
    "variantId": "62048618119436",
    "priceCents": 119190,
    "sku": "DWECO-KIT-180-H4-200"
  },
  "180:H4:250": {
    "variantId": "62048618152204",
    "priceCents": 119190,
    "sku": "DWECO-KIT-180-H4-250"
  },
  "180:H4:300": {
    "variantId": "62048618184972",
    "priceCents": 123590,
    "sku": "DWECO-KIT-180-H4-300"
  },
  "180:H4:360": {
    "variantId": "62048618217740",
    "priceCents": 123590,
    "sku": "DWECO-KIT-180-H4-360"
  },
  "180:H5:50": {
    "variantId": "62048618250508",
    "priceCents": 110090,
    "sku": "DWECO-KIT-180-H5-050"
  },
  "180:H5:100": {
    "variantId": "62048618283276",
    "priceCents": 111990,
    "sku": "DWECO-KIT-180-H5-100"
  },
  "180:H5:150": {
    "variantId": "62048618316044",
    "priceCents": 112990,
    "sku": "DWECO-KIT-180-H5-150"
  },
  "180:H5:200": {
    "variantId": "62048618348812",
    "priceCents": 114190,
    "sku": "DWECO-KIT-180-H5-200"
  },
  "180:H5:250": {
    "variantId": "62048618381580",
    "priceCents": 114190,
    "sku": "DWECO-KIT-180-H5-250"
  },
  "180:H5:300": {
    "variantId": "62048618414348",
    "priceCents": 118590,
    "sku": "DWECO-KIT-180-H5-300"
  },
  "180:H5:360": {
    "variantId": "62048618447116",
    "priceCents": 118590,
    "sku": "DWECO-KIT-180-H5-360"
  },
  "180:H6:50": {
    "variantId": "62048618479884",
    "priceCents": 123090,
    "sku": "DWECO-KIT-180-H6-050"
  },
  "180:H6:100": {
    "variantId": "62048618512652",
    "priceCents": 124990,
    "sku": "DWECO-KIT-180-H6-100"
  },
  "180:H6:150": {
    "variantId": "62048618545420",
    "priceCents": 125990,
    "sku": "DWECO-KIT-180-H6-150"
  },
  "180:H6:200": {
    "variantId": "62048618578188",
    "priceCents": 127190,
    "sku": "DWECO-KIT-180-H6-200"
  },
  "180:H6:250": {
    "variantId": "62048618610956",
    "priceCents": 127190,
    "sku": "DWECO-KIT-180-H6-250"
  },
  "180:H6:300": {
    "variantId": "62048618643724",
    "priceCents": 131590,
    "sku": "DWECO-KIT-180-H6-300"
  },
  "180:H6:360": {
    "variantId": "62048618676492",
    "priceCents": 131590,
    "sku": "DWECO-KIT-180-H6-360"
  },
  "180:H7:50": {
    "variantId": "62048618709260",
    "priceCents": 141190,
    "sku": "DWECO-KIT-180-H7-050"
  },
  "180:H7:100": {
    "variantId": "62048618742028",
    "priceCents": 144990,
    "sku": "DWECO-KIT-180-H7-100"
  },
  "180:H7:150": {
    "variantId": "62048618774796",
    "priceCents": 145990,
    "sku": "DWECO-KIT-180-H7-150"
  },
  "180:H7:200": {
    "variantId": "62048618807564",
    "priceCents": 148390,
    "sku": "DWECO-KIT-180-H7-200"
  },
  "180:H7:250": {
    "variantId": "62048618840332",
    "priceCents": 148390,
    "sku": "DWECO-KIT-180-H7-250"
  },
  "180:H7:300": {
    "variantId": "62048618873100",
    "priceCents": 154990,
    "sku": "DWECO-KIT-180-H7-300"
  },
  "180:H7:360": {
    "variantId": "62048618905868",
    "priceCents": 154990,
    "sku": "DWECO-KIT-180-H7-360"
  },
  "180:H8:50": {
    "variantId": "62048618938636",
    "priceCents": 154190,
    "sku": "DWECO-KIT-180-H8-050"
  },
  "180:H8:100": {
    "variantId": "62048618971404",
    "priceCents": 157990,
    "sku": "DWECO-KIT-180-H8-100"
  },
  "180:H8:150": {
    "variantId": "62048619004172",
    "priceCents": 158990,
    "sku": "DWECO-KIT-180-H8-150"
  },
  "180:H8:200": {
    "variantId": "62048619036940",
    "priceCents": 161390,
    "sku": "DWECO-KIT-180-H8-200"
  },
  "180:H8:250": {
    "variantId": "62048619069708",
    "priceCents": 161390,
    "sku": "DWECO-KIT-180-H8-250"
  },
  "180:H8:300": {
    "variantId": "62048619102476",
    "priceCents": 167990,
    "sku": "DWECO-KIT-180-H8-300"
  },
  "180:H8:360": {
    "variantId": "62048619135244",
    "priceCents": 167990,
    "sku": "DWECO-KIT-180-H8-360"
  },
  "180:H9:50": {
    "variantId": "62048619168012",
    "priceCents": 167190,
    "sku": "DWECO-KIT-180-H9-050"
  },
  "180:H9:100": {
    "variantId": "62048619200780",
    "priceCents": 170990,
    "sku": "DWECO-KIT-180-H9-100"
  },
  "180:H9:150": {
    "variantId": "62048619233548",
    "priceCents": 171990,
    "sku": "DWECO-KIT-180-H9-150"
  },
  "180:H9:200": {
    "variantId": "62048619266316",
    "priceCents": 174390,
    "sku": "DWECO-KIT-180-H9-200"
  },
  "180:H9:250": {
    "variantId": "62048619299084",
    "priceCents": 174390,
    "sku": "DWECO-KIT-180-H9-250"
  },
  "180:H9:300": {
    "variantId": "62048619331852",
    "priceCents": 180990,
    "sku": "DWECO-KIT-180-H9-300"
  },
  "180:H9:360": {
    "variantId": "62048619364620",
    "priceCents": 180990,
    "sku": "DWECO-KIT-180-H9-360"
  },
  "180:H10:50": {
    "variantId": "62048619397388",
    "priceCents": 181190,
    "sku": "DWECO-KIT-180-H10-050"
  },
  "180:H10:100": {
    "variantId": "62048619430156",
    "priceCents": 184990,
    "sku": "DWECO-KIT-180-H10-100"
  },
  "180:H10:150": {
    "variantId": "62048619462924",
    "priceCents": 185990,
    "sku": "DWECO-KIT-180-H10-150"
  },
  "180:H10:200": {
    "variantId": "62048619495692",
    "priceCents": 188390,
    "sku": "DWECO-KIT-180-H10-200"
  },
  "180:H10:250": {
    "variantId": "62048619528460",
    "priceCents": 188390,
    "sku": "DWECO-KIT-180-H10-250"
  },
  "180:H10:300": {
    "variantId": "62048619561228",
    "priceCents": 194990,
    "sku": "DWECO-KIT-180-H10-300"
  },
  "180:H10:360": {
    "variantId": "62048619593996",
    "priceCents": 194990,
    "sku": "DWECO-KIT-180-H10-360"
  },
  "180:H11:50": {
    "variantId": "62048619626764",
    "priceCents": 198290,
    "sku": "DWECO-KIT-180-H11-050"
  },
  "180:H11:100": {
    "variantId": "62048619659532",
    "priceCents": 203990,
    "sku": "DWECO-KIT-180-H11-100"
  },
  "180:H11:150": {
    "variantId": "62048619692300",
    "priceCents": 204990,
    "sku": "DWECO-KIT-180-H11-150"
  },
  "180:H11:200": {
    "variantId": "62048619725068",
    "priceCents": 208590,
    "sku": "DWECO-KIT-180-H11-200"
  },
  "180:H11:250": {
    "variantId": "62048619757836",
    "priceCents": 208590,
    "sku": "DWECO-KIT-180-H11-250"
  },
  "180:H11:300": {
    "variantId": "62048619790604",
    "priceCents": 217390,
    "sku": "DWECO-KIT-180-H11-300"
  },
  "180:H11:360": {
    "variantId": "62048619823372",
    "priceCents": 217390,
    "sku": "DWECO-KIT-180-H11-360"
  },
  "200:H1:50": {
    "variantId": "62048619856140",
    "priceCents": 105990,
    "sku": "DWECO-KIT-200-H1-050"
  },
  "200:H1:100": {
    "variantId": "62048619888908",
    "priceCents": 108990,
    "sku": "DWECO-KIT-200-H1-100"
  },
  "200:H1:150": {
    "variantId": "62048619921676",
    "priceCents": 108990,
    "sku": "DWECO-KIT-200-H1-150"
  },
  "200:H1:200": {
    "variantId": "62048619954444",
    "priceCents": 110190,
    "sku": "DWECO-KIT-200-H1-200"
  },
  "200:H1:250": {
    "variantId": "62048619987212",
    "priceCents": 112390,
    "sku": "DWECO-KIT-200-H1-250"
  },
  "200:H1:300": {
    "variantId": "62048620019980",
    "priceCents": 114790,
    "sku": "DWECO-KIT-200-H1-300"
  },
  "200:H1:360": {
    "variantId": "62048620052748",
    "priceCents": 114790,
    "sku": "DWECO-KIT-200-H1-360"
  },
  "200:H2:50": {
    "variantId": "62048620085516",
    "priceCents": 113990,
    "sku": "DWECO-KIT-200-H2-050"
  },
  "200:H2:100": {
    "variantId": "62048620118284",
    "priceCents": 116990,
    "sku": "DWECO-KIT-200-H2-100"
  },
  "200:H2:150": {
    "variantId": "62048620151052",
    "priceCents": 116990,
    "sku": "DWECO-KIT-200-H2-150"
  },
  "200:H2:200": {
    "variantId": "62048620183820",
    "priceCents": 118190,
    "sku": "DWECO-KIT-200-H2-200"
  },
  "200:H2:250": {
    "variantId": "62048620216588",
    "priceCents": 120390,
    "sku": "DWECO-KIT-200-H2-250"
  },
  "200:H2:300": {
    "variantId": "62048620249356",
    "priceCents": 122790,
    "sku": "DWECO-KIT-200-H2-300"
  },
  "200:H2:360": {
    "variantId": "62048620282124",
    "priceCents": 122790,
    "sku": "DWECO-KIT-200-H2-360"
  },
  "200:H3:50": {
    "variantId": "62048620314892",
    "priceCents": 119990,
    "sku": "DWECO-KIT-200-H3-050"
  },
  "200:H3:100": {
    "variantId": "62048620347660",
    "priceCents": 122990,
    "sku": "DWECO-KIT-200-H3-100"
  },
  "200:H3:150": {
    "variantId": "62048620380428",
    "priceCents": 122990,
    "sku": "DWECO-KIT-200-H3-150"
  },
  "200:H3:200": {
    "variantId": "62048620413196",
    "priceCents": 124190,
    "sku": "DWECO-KIT-200-H3-200"
  },
  "200:H3:250": {
    "variantId": "62048620445964",
    "priceCents": 126390,
    "sku": "DWECO-KIT-200-H3-250"
  },
  "200:H3:300": {
    "variantId": "62048620478732",
    "priceCents": 128790,
    "sku": "DWECO-KIT-200-H3-300"
  },
  "200:H3:360": {
    "variantId": "62048620511500",
    "priceCents": 128790,
    "sku": "DWECO-KIT-200-H3-360"
  },
  "200:H4:50": {
    "variantId": "62048620544268",
    "priceCents": 125990,
    "sku": "DWECO-KIT-200-H4-050"
  },
  "200:H4:100": {
    "variantId": "62048620577036",
    "priceCents": 128990,
    "sku": "DWECO-KIT-200-H4-100"
  },
  "200:H4:150": {
    "variantId": "62048620609804",
    "priceCents": 128990,
    "sku": "DWECO-KIT-200-H4-150"
  },
  "200:H4:200": {
    "variantId": "62048620642572",
    "priceCents": 130190,
    "sku": "DWECO-KIT-200-H4-200"
  },
  "200:H4:250": {
    "variantId": "62048620675340",
    "priceCents": 132390,
    "sku": "DWECO-KIT-200-H4-250"
  },
  "200:H4:300": {
    "variantId": "62048620708108",
    "priceCents": 134790,
    "sku": "DWECO-KIT-200-H4-300"
  },
  "200:H4:360": {
    "variantId": "62048620740876",
    "priceCents": 134790,
    "sku": "DWECO-KIT-200-H4-360"
  },
  "200:H5:50": {
    "variantId": "62048620773644",
    "priceCents": 119990,
    "sku": "DWECO-KIT-200-H5-050"
  },
  "200:H5:100": {
    "variantId": "62048620806412",
    "priceCents": 122990,
    "sku": "DWECO-KIT-200-H5-100"
  },
  "200:H5:150": {
    "variantId": "62048620839180",
    "priceCents": 122990,
    "sku": "DWECO-KIT-200-H5-150"
  },
  "200:H5:200": {
    "variantId": "62048620871948",
    "priceCents": 124190,
    "sku": "DWECO-KIT-200-H5-200"
  },
  "200:H5:250": {
    "variantId": "62048620904716",
    "priceCents": 126390,
    "sku": "DWECO-KIT-200-H5-250"
  },
  "200:H5:300": {
    "variantId": "62048620937484",
    "priceCents": 128790,
    "sku": "DWECO-KIT-200-H5-300"
  },
  "200:H5:360": {
    "variantId": "62048620970252",
    "priceCents": 128790,
    "sku": "DWECO-KIT-200-H5-360"
  },
  "200:H6:50": {
    "variantId": "62048621003020",
    "priceCents": 134990,
    "sku": "DWECO-KIT-200-H6-050"
  },
  "200:H6:100": {
    "variantId": "62048621035788",
    "priceCents": 137990,
    "sku": "DWECO-KIT-200-H6-100"
  },
  "200:H6:150": {
    "variantId": "62048621068556",
    "priceCents": 137990,
    "sku": "DWECO-KIT-200-H6-150"
  },
  "200:H6:200": {
    "variantId": "62048621101324",
    "priceCents": 139190,
    "sku": "DWECO-KIT-200-H6-200"
  },
  "200:H6:250": {
    "variantId": "62048621134092",
    "priceCents": 141390,
    "sku": "DWECO-KIT-200-H6-250"
  },
  "200:H6:300": {
    "variantId": "62048621166860",
    "priceCents": 143790,
    "sku": "DWECO-KIT-200-H6-300"
  },
  "200:H6:360": {
    "variantId": "62048621199628",
    "priceCents": 143790,
    "sku": "DWECO-KIT-200-H6-360"
  },
  "200:H7:50": {
    "variantId": "62048621232396",
    "priceCents": 153990,
    "sku": "DWECO-KIT-200-H7-050"
  },
  "200:H7:100": {
    "variantId": "62048621265164",
    "priceCents": 158990,
    "sku": "DWECO-KIT-200-H7-100"
  },
  "200:H7:150": {
    "variantId": "62048621297932",
    "priceCents": 158990,
    "sku": "DWECO-KIT-200-H7-150"
  },
  "200:H7:200": {
    "variantId": "62048621330700",
    "priceCents": 161390,
    "sku": "DWECO-KIT-200-H7-200"
  },
  "200:H7:250": {
    "variantId": "62048621363468",
    "priceCents": 163590,
    "sku": "DWECO-KIT-200-H7-250"
  },
  "200:H7:300": {
    "variantId": "62048621396236",
    "priceCents": 168390,
    "sku": "DWECO-KIT-200-H7-300"
  },
  "200:H7:360": {
    "variantId": "62048621429004",
    "priceCents": 168390,
    "sku": "DWECO-KIT-200-H7-360"
  },
  "200:H8:50": {
    "variantId": "62048621461772",
    "priceCents": 168990,
    "sku": "DWECO-KIT-200-H8-050"
  },
  "200:H8:100": {
    "variantId": "62048621494540",
    "priceCents": 173990,
    "sku": "DWECO-KIT-200-H8-100"
  },
  "200:H8:150": {
    "variantId": "62048621527308",
    "priceCents": 173990,
    "sku": "DWECO-KIT-200-H8-150"
  },
  "200:H8:200": {
    "variantId": "62048621560076",
    "priceCents": 176390,
    "sku": "DWECO-KIT-200-H8-200"
  },
  "200:H8:250": {
    "variantId": "62048621592844",
    "priceCents": 178590,
    "sku": "DWECO-KIT-200-H8-250"
  },
  "200:H8:300": {
    "variantId": "62048621625612",
    "priceCents": 183390,
    "sku": "DWECO-KIT-200-H8-300"
  },
  "200:H8:360": {
    "variantId": "62048621658380",
    "priceCents": 183390,
    "sku": "DWECO-KIT-200-H8-360"
  },
  "200:H9:50": {
    "variantId": "62048621691148",
    "priceCents": 183990,
    "sku": "DWECO-KIT-200-H9-050"
  },
  "200:H9:100": {
    "variantId": "62048621723916",
    "priceCents": 188990,
    "sku": "DWECO-KIT-200-H9-100"
  },
  "200:H9:150": {
    "variantId": "62048621756684",
    "priceCents": 188990,
    "sku": "DWECO-KIT-200-H9-150"
  },
  "200:H9:200": {
    "variantId": "62048621789452",
    "priceCents": 191390,
    "sku": "DWECO-KIT-200-H9-200"
  },
  "200:H9:250": {
    "variantId": "62048621822220",
    "priceCents": 193590,
    "sku": "DWECO-KIT-200-H9-250"
  },
  "200:H9:300": {
    "variantId": "62048621854988",
    "priceCents": 198390,
    "sku": "DWECO-KIT-200-H9-300"
  },
  "200:H9:360": {
    "variantId": "62048621887756",
    "priceCents": 198390,
    "sku": "DWECO-KIT-200-H9-360"
  },
  "200:H10:50": {
    "variantId": "62048621920524",
    "priceCents": 198990,
    "sku": "DWECO-KIT-200-H10-050"
  },
  "200:H10:100": {
    "variantId": "62048621953292",
    "priceCents": 203990,
    "sku": "DWECO-KIT-200-H10-100"
  },
  "200:H10:150": {
    "variantId": "62048621986060",
    "priceCents": 203990,
    "sku": "DWECO-KIT-200-H10-150"
  },
  "200:H10:200": {
    "variantId": "62048622018828",
    "priceCents": 206390,
    "sku": "DWECO-KIT-200-H10-200"
  },
  "200:H10:250": {
    "variantId": "62048622051596",
    "priceCents": 208590,
    "sku": "DWECO-KIT-200-H10-250"
  },
  "200:H10:300": {
    "variantId": "62048622084364",
    "priceCents": 213390,
    "sku": "DWECO-KIT-200-H10-300"
  },
  "200:H10:360": {
    "variantId": "62048622117132",
    "priceCents": 213390,
    "sku": "DWECO-KIT-200-H10-360"
  },
  "200:H11:50": {
    "variantId": "62048622149900",
    "priceCents": 217990,
    "sku": "DWECO-KIT-200-H11-050"
  },
  "200:H11:100": {
    "variantId": "62048622182668",
    "priceCents": 224990,
    "sku": "DWECO-KIT-200-H11-100"
  },
  "200:H11:150": {
    "variantId": "62048622215436",
    "priceCents": 224990,
    "sku": "DWECO-KIT-200-H11-150"
  },
  "200:H11:200": {
    "variantId": "62048622248204",
    "priceCents": 228590,
    "sku": "DWECO-KIT-200-H11-200"
  },
  "200:H11:250": {
    "variantId": "62048622280972",
    "priceCents": 230790,
    "sku": "DWECO-KIT-200-H11-250"
  },
  "200:H11:300": {
    "variantId": "62048622313740",
    "priceCents": 237990,
    "sku": "DWECO-KIT-200-H11-300"
  },
  "200:H11:360": {
    "variantId": "62048622346508",
    "priceCents": 237990,
    "sku": "DWECO-KIT-200-H11-360"
  }
});

  function key(dn, heightClassId, wallDistanceMm) {
    return `${Number(dn)}:${String(heightClassId || '').toUpperCase()}:${Number(wallDistanceMm)}`;
  }

  function get(dn, heightClassId, wallDistanceMm) {
    return VARIANTS[key(dn, heightClassId, wallDistanceMm)] || null;
  }

  const api = Object.freeze({ VARIANTS, key, get });
  global.JeremiasDwEcoKitVariants = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
